import React from "react";
import { FiExternalLink } from "react-icons/fi";
import { LinkThreeData } from "../../types";
import utils from "../../helpers/utils";

interface LinksPreviewProps {
  data: LinkThreeData;
}

export default function LinksPreview({ data }: LinksPreviewProps) {
  return (
    <div
      className="hidden w-2/5 border-r border-stroke lg:block dark:border-strokedark"
      style={{
        background: data.background || "#0F172A",
      }}
    >
      <div className="flex h-full flex-col items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Preview do Perfil */}
          <div className="mb-6 text-center">
            {data.photo && (
              <div className="mx-auto mb-4 h-24 w-24 overflow-hidden rounded-full border-4 border-white shadow-xl">
                <img
                  src={utils.getUriImage(data.photo)}
                  alt={data.name || "Profile"}
                  className="h-full w-full object-contain"
                />
              </div>
            )}
            <h3
              className="text-2xl font-bold"
              style={{ color: data.color || "#FFFFFF" }}
            >
              {data.name || "Seu Nome"}
            </h3>
            {data.description && (
              <p
                className="mt-2 text-sm opacity-90"
                style={{ color: data.color_secondary || "#E2E8F0" }}
              >
                {data.description}
              </p>
            )}
          </div>

          {/* Preview dos Botões */}
          <div className="space-y-3">
            {data.buttons && data.buttons.length > 0 ? (
              data.buttons.slice(0, 5).map((button) => (
                <div
                  key={button.id}
                  className="group relative flex items-center justify-between overflow-hidden rounded-xl p-4 shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-2xl"
                  style={{
                    backgroundColor: data.color || "#1E293B",
                  }}
                >
                  {/* Background Gradient Effect on Hover */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

                  <div className="relative flex w-full items-center justify-between">
                    <div className="flex-shrink-0">
                      <div className="h-14 w-14 overflow-hidden rounded-lg bg-white/10 p-1">
                        {button.image && (
                          <img
                            src={utils.getUriImage(button.image)}
                            alt={button.label}
                            className="h-full w-full rounded-md object-contain"
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex-1 px-4 text-center">
                      <span
                        className="font-semibold"
                        style={{
                          color: data.color_secondary || "#FFFFFF",
                        }}
                      >
                        {button.label}
                      </span>
                    </div>
                    <div className="flex-shrink-0">
                      <FiExternalLink
                        size={18}
                        style={{
                          color: data.color_secondary || "#FFFFFF",
                        }}
                        className="opacity-70 transition-opacity group-hover:opacity-100"
                      />
                    </div>
                  </div>

                  {/* Shine Effect */}
                  <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full"></div>
                </div>
              ))
            ) : (
              <div className="rounded-xl bg-white/20 p-8 text-center backdrop-blur-sm">
                <p className="text-white">Adicione seus primeiros links</p>
              </div>
            )}
          </div>

          <p className="mt-4 text-center text-xs text-white opacity-70">
            Preview em tempo real
          </p>
        </div>
      </div>
    </div>
  );
}
